<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="" class="fn-left">
            <Select key="4" :selected.sync="listQuery.food_type" :data="selectList" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-input
              v-model="listQuery.food_name"
              placeholder="输入菜品名称"
            />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetFoodList">查询</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnAddFood()">添加</el-button>
          </el-form-item>
        </el-form>

      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="菜品ID" prop="food_id" align="center" />
        <el-table-column label="菜品分类" prop="food_type_name" align="center" />
        <el-table-column label="菜品封面" align="center">
          <template slot-scope="{row}">
            <img :src="row.food_picture" alt="" width="60" height="60" style="width: 60px!important;height: 60px!important;">
          </template>
        </el-table-column>
        <el-table-column label="菜品名称" prop="food_name" align="center" />
        <el-table-column label="食材及数量(g)" prop="food_material" align="center" />
        <el-table-column label="更新时间" prop="modify_time" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnEditFood(row)">编辑</el-button>
            <el-button type="text" style="color:red!important" @click="fnDeleteFood(row.food_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="listQuery.p"
          prev-text="上一页"
          next-text="下一页"
          :total="total"
          :page-size="listQuery.limit"
          @current-change="fnGetFoodList"
        >
          <div class="chax">
            {{ listQuery.p }}/{{
              total > 0 ? Math.ceil(total / listQuery.limit) : 1
            }}
          </div>
        </el-pagination>
        <div class="insert">
          <el-button type="primary">确定</el-button>
          <span class="pagination-count">
            符合查询结果:
            <i>{{ total }}条</i>
          </span>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogAddFoodVisible" title="添加/编辑菜品" width="500px">
      <add-food ref="addFoodDialog" :key="dialogAddFoodKey" :food="currentFood" @successCBK="fnAddSuccess()" />
    </el-dialog>
  </div>

</template>
<script>
import Select from '@/components/Select'
import AddFood from './AddFood'
export default {
  name: 'FoodMenuManage',
  components: {
    Select,
    AddFood
  },
  data() {
    return {
      selectList: [],
      lists: [],
      dialogAddFoodKey: 0,
      dialogAddFoodVisible: false,
      tableKey: 0,
      total: 0,
      currentFood: '',
      listQuery: {
        p: 1,
        limit: 20,
        food_type: '',
        food_name: ''
      }
    }
  },
  created() {
    this.fnGetFoodList()
    this.fnGetSelectList()
  },
  methods: {
    changeType: function() {

    },
    search: function() {

    },
    fnGetFoodList: function() {
      this.$http.getFoodList(this.listQuery).then(res => {
        this.tableKey++
        this.lists = res.data.list
        this.total = parseInt(res.data.count)
      })
    },
    fnGetSelectList: function() {
      this.$http.getDeploy().then(res => {
        this.selectList = res.data.food_type
      })
    },
    fnDeleteFood: function(id) {
      this.$confirm('确认删除该菜品？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delFoodList({ food_id: id }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.fnGetFoodList()
        })
      }).catch(() => {

      })
    },
    fnAddSuccess: function() {
      this.dialogAddFoodVisible = false
      this.fnGetFoodList()
    },
    fnEditFood: function(food) {
      this.currentFood = food
      this.dialogAddFoodKey += 1
      this.dialogAddFoodVisible = true
    },
    fnAddFood: function() {
      this.currentFood = ''
      this.dialogAddFoodKey += 1
      this.dialogAddFoodVisible = true
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
